import { useCurrentBox } from "@modules/box/hooks/useBox"
import { useServicesContext } from "@modules/core/services/services.context"
import { BoxPromoCodeEntity } from "@modules/promoCode/entities/boxPromoCodeEntity"
import { PromoCodeEntity } from "@modules/promoCode/entities/promoCodeEntity"
import { type BoxPromoCodeDto } from "@modules/promoCode/gateway/boxPromoCodeDto"
import { type CoachPromoCodeDto } from "@modules/promoCode/gateway/promoCodeDto"
import { useQuery } from "@tanstack/react-query"

export const usePromoCodesBoxOrCoach = (expired: boolean) => {
  const { promoCodeApi, boxPromoCodeApi } = useServicesContext()
  const { result: box } = useCurrentBox()
  const queryKey = box ? ["boxPromoCodes", expired] : ["promoCodes", expired]

  const {
    data: promoCodes,
    isLoading,
    error,
    refetch,
  } = useQuery<CoachPromoCodeDto[] | BoxPromoCodeDto[]>({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey,
    queryFn: async () => {
      return box ? await boxPromoCodeApi.getBoxPromoCodes(expired) : await promoCodeApi.getPromoCodes(expired)
    },
  })

  return {
    promoCodes:
      promoCodes?.map((dto) =>
        box ? BoxPromoCodeEntity.fromDto(dto as BoxPromoCodeDto) : PromoCodeEntity.fromDto(dto as CoachPromoCodeDto),
      ) ?? [],
    isLoading,
    error,
    refetch,
  }
}
